import React from "react"
import { api_freedom } from '../services/apis'
import moment from 'moment'
import jwt_decode from 'jwt-decode'
import ModalErroGerarBoletoEmMassa from "./ModalErroGerarBoletoEmMassa"
import jwt from 'jsonwebtoken'

class GerarBoletos extends React.Component {

    constructor(props) {
        super(props)
        if (!localStorage.getItem('autenticado_freedom')) {
            props.history.push('/')
        }

        this.state = {
            data_inicio: moment().format('YYYY-MM-DD'),
            data_fim: moment().add(1, 'months').format('YYYY-MM-DD'),
            mes_ano: moment().format('YYYY-MM'),
            boletos: [],
            servicos: [],
            mensagem: 'Carregando ....',
            total_boletos: 0,
            modal_titulo: '',
            modal_corpo: '',
            modal_botoes: '',
            blockBtn: false,
            modalErroGerarBoleto: ''
        }

    }

    componentDidMount() {
        this.boletos(moment().format('YYYY-MM-DD'), moment().add(1, 'months').format('YYYY-MM-DD'), moment().format('YYYY-MM'))
    }

    getSymbolForService = (servico) => {
        const { gerar_boleto, somar_repasse, descontar_repasse, credito_debito } = servico;

  if (credito_debito === 1 && gerar_boleto === 1 && somar_repasse === 1 && descontar_repasse === 0) {
    return 'P'; // Crédito Proprietário
}

if (credito_debito === 1 && gerar_boleto === 1 && somar_repasse === 0 && descontar_repasse === 0) {
    return 'I'; // Crédito Imobiliária
}

if (credito_debito === 0 && gerar_boleto === 0 && somar_repasse === 0 && descontar_repasse === 1) {
    return 'I'; // Crédito Imobiliária
}

if (credito_debito === 1 && gerar_boleto === 0 && somar_repasse === 1 && descontar_repasse === 0) {
    return 'P'; // Crédito Proprietário
}

if (credito_debito === 0 &&  gerar_boleto === 1 && somar_repasse === 0 && descontar_repasse === 0) {
    return 'L'; // Crédito Locatário
}

if (credito_debito === 0 &&  gerar_boleto === 1 && somar_repasse === 0 && descontar_repasse === 1) {
    return 'L'; // Crédito Locatário
}




        return '';
    }

    getColorForSymbol = (symbol) => {
        switch (symbol) {
            case 'P': return '#28a745';
            case 'I': return '#007bff';
            case 'L': return '#dc3545';
            default: return '#6c757d';
        }
    }

    boletos = async (inicio, fim, mes_ano) => {
        try {
            let boletos = await api_freedom.post(`/financeiro/vencimentomes`,
                {
                    data_inicio: inicio,
                    data_fim: fim,
                    mes_ano: mes_ano,
                    imobiliaria_id: jwt_decode(localStorage.getItem('autenticado_freedom')).imobiliaria_id
                },
                {
                    headers: { "authorization": localStorage.getItem('autenticado_freedom') }
                })
            if (boletos.data.data.indexOf('TOKEN') === -1) {
                const boletosFiltrados = boletos.data.data.filter((b) => {
                    return b.nome === 'Aluguel'
                });

                if (boletosFiltrados.length === 0) {
                    this.fecharModal()
                }

                const servicosMap = new Map();

                boletos.data.data
                    .filter(item =>
                        !['Aluguel', 'Repasse de aluguel'].includes(item.nome) &&
                        item.gerar_boleto === 1
                    )
                    .forEach(item => {
                        if (!servicosMap.has(item.nome)) {
                            servicosMap.set(item.nome, {
                                nome: item.nome,
                                credito_debito: item.credito_debito,
                                gerar_boleto: item.gerar_boleto,
                                somar_repasse: item.somar_repasse,
                                descontar_repasse: item.descontar_repasse
                            });
                        }
                    });

                const servicosUnicos = Array.from(servicosMap.values()).sort((a, b) => a.nome.localeCompare(b.nome));

                this.setState({
                    boletos: boletos.data.data,
                    servicos: servicosUnicos,
                    mensagem: 'Nenhum registro encontrado.',
                    total_boletos: boletosFiltrados.length
                })
            }
        }
        catch (error) {
            console.log(error.message)
        }
    }

    getServicoValor = (contrato_id, mes_ano, nomeServico) => {
        const servicos = this.state.boletos.filter(item =>
            item.contrato_id === contrato_id &&
            item.mes_ano === mes_ano &&
            item.nome === nomeServico &&
            item.gerar_boleto === 1
        );

        if (servicos.length === 0) return null;

        let valor = 0;
        servicos.forEach(servico => {
            if (servico.credito_debito === 1) {
                valor += parseFloat(servico.valor);
            } else {
                valor -= parseFloat(servico.valor);
            }
        });

        return valor;
    }

    genCSV = () => {
        let csv = 'Contrato,Parcela,Mês referente,Vencimento,Valor do aluguel,';

        for (const servicoInfo of this.state.servicos) {
            csv += servicoInfo.nome + ","
        }

        csv += "Valor do boleto,Vencimento do boleto,Pago?"
        csv += "\n"

        const boletosAluguel = this.state.boletos.filter((p) => {
            return p.nome === 'Aluguel'
        });

        for (const record of boletosAluguel) {
            var valor_boleto = 0

            this.state.boletos.filter((p) => {
                return p.contrato_id === record.contrato_id && p.gerar_boleto === 1 && p.mes_ano === record.mes_ano
            }).forEach((f) => {
                if (f.credito_debito === 1) {
                    valor_boleto += parseFloat(f.valor)
                }
                else {
                    valor_boleto -= parseFloat(f.valor)
                }
            })

            csv += `${record.contrato_id},`
            csv += `${record.id},`
            csv += `"${this.capitalize(new Date(record.mes_ano).toLocaleString('pt-BR', { month: 'long' }))}",`
            csv += `${moment(record.data_vencimento).utc(false).format('DD/MM/YYYY')},`
            csv += `"${parseFloat(record.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}",`

            for (const servicoInfo of this.state.servicos) {
                const valor = this.getServicoValor(record.contrato_id, record.mes_ano, servicoInfo.nome);

                if (valor !== null) {
                    const symbol = this.getSymbolForService(servicoInfo);
                    let indicador = '';

                    switch (symbol) {
                        case 'P': indicador = ' - Proprietário'; break;
                        case 'I': indicador = ' - Imobiliária'; break;
                        case 'L': indicador = ' - Locatário'; break;
                        default: indicador = '';
                    }

                    csv += `"${valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}${indicador}",`;
                } else {
                    csv += `"---",`;
                }
            }

            csv += `"${record.boleto_valor ? parseFloat(record.boleto_valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : valor_boleto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}",`
            csv += `${record.boleto_vencimento ? moment(record.boleto_vencimento).utc(false).format('DD/MM/YYYY') : "Não gerado"},`
            csv += `${record.pago ? "Sim, dia " + moment(record.pago).utc(false).format('DD/MM/YYYY') : "Não"},`
            csv += "\n"
        }

        csv = csv.slice(0, csv.length - 1)

        var hiddenElement = document.createElement('a');
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
        hiddenElement.target = '_blank';
        hiddenElement.download = 'boletos_gerar.csv';
        hiddenElement.click();
    }

    listarBoletos = (record, index) => {
        var valor_boleto = 0

        this.state.boletos.filter((p) => {
            return p.contrato_id === record.contrato_id && p.gerar_boleto === 1 && p.mes_ano === record.mes_ano
        }).forEach((f) => {
            if (f.credito_debito === 1) {
                valor_boleto += parseFloat(f.valor)
            }
            else {
                valor_boleto -= parseFloat(f.valor)
            }
        })

        return (
            <tr key={index}>
                <td>{record.contrato_id}</td>
                <td>{record.id}</td>
                <td>{this.capitalize(new Date(record.mes_ano).toLocaleString('pt-BR', { month: 'long' }))} </td>
                <td>{moment(record.data_vencimento).utc(false).format('DD/MM/YYYY')}</td>
                <td>{parseFloat(record.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>

                {this.state.servicos.map(servicoInfo => {
                    const valor = this.getServicoValor(record.contrato_id, record.mes_ano, servicoInfo.nome);
                    const symbol = this.getSymbolForService(servicoInfo);

                    return (
                        <td key={servicoInfo.nome}>
                            {valor !== null ? (
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '4px'
                                }}>
                                    {symbol && (
                                        <span style={{
                                            backgroundColor: this.getColorForSymbol(symbol),
                                            color: 'white',
                                            borderRadius: '50%',
                                            width: '16px',
                                            height: '16px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '9px',
                                            fontWeight: 'bold'
                                        }}>
                                            {symbol}
                                        </span>
                                    )}
                                    <span>
                                        {valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                    </span>
                                </div>
                            ) : '---'}
                        </td>
                    );
                })}

                <td>{record.boleto_valor ? parseFloat(record.boleto_valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : valor_boleto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                    <button className='ml-3' style={{ border: '1px solid #6b24d6', borderRadius: '2px', padding: '0px 10px', backgroundColor: '#6b24d6', color: 'white' }}
                        onClick={() => { this.props.history.push(`/freedom/detalheparcela/${record.contrato_id}/${record.id}`) }}> ? </button>
                </td>
                <td>{record.boleto_vencimento ? moment(record.boleto_vencimento).utc(false).format('DD/MM/YYYY') : 'Não gerado'}</td>
                <td>{record.pago ? `Sim, dia ${moment(record.pago).utc(false).format('DD/MM/YYYY')}` : `Não`}</td>
            </tr>
        )
    }

    capitalize = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1)
    }

    abrirModal = () => {
        var modal = document.getElementById('modal');
        modal.style.display = "flex";
    }

    fecharModal = () => {
        var modal = document.getElementById('modal');
        modal.style.display = "none";
    }

    fecharModalErro = () => {
        this.setState({ modalErroGerarBoleto: '' })
    }

    boletosGerar = async () => {
        if (this.state.blockBtn) return
        document.querySelector("#gen_boletos").disabled = true
        this.state.blockBtn = true

        this.setState({
            modal_titulo: `Gerando boletos`,
            modal_corpo: <div className='text-center' style={{ padding: '2vw', fontSize: '1.1em' }}>
                AGUARDE....
            </div>,
            modal_botoes: <></>
        })
        this.abrirModal()
        await this.gerarBoleto()
        document.querySelector("#gen_boletos").disabled = false
        this.state.blockBtn = false
        this.fecharModal()
    }

    gerarBoleto = async () => {
        try {
            let financeiro = await api_freedom.post(`/financeiro/gerarboleto`, {
                data_inicio: this.state.data_inicio,
                data_fim: this.state.data_fim,
                mes_ano: this.state.mes_ano,
                imobiliaria_id: jwt_decode(localStorage.getItem('autenticado_freedom')).imobiliaria_id
            }, { headers: { "authorization": localStorage.getItem('autenticado_freedom') } })

            if (financeiro.data.data.length > 0) {
                this.boletos(this.state.data_inicio, this.state.data_fim, this.state.mes_ano)
            }
            if (financeiro.data.erro.length > 0) {

                console.log(financeiro.data);

                this.setState({
                    modalErroGerarBoleto: <ModalErroGerarBoletoEmMassa
                        erros={financeiro.data.erro}
                        fechar={this.fecharModalErro}
                    />
                })
            }
        } catch (error) {
            console.log(error.message)
        }
    }

    disable_button() {
        if (jwt_decode(localStorage.getItem('autenticado_freedom')).permissao_tipo === "Read") {
            return true
        } else {
            return false
        }
    }

    render() {
        return (
            <>
                <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div>
                            <div style={{ padding: '0.2vw' }} className="grupo__campo">
                                Data inicial:
                                <div className="grupo__campo__form grupo__campo--input--select">
                                    <input type='date' style={{ width: '150px' }} defaultValue={moment().format('YYYY-MM-DD')}
                                        onChange={(event) => {
                                            this.setState({ data_inicio: event.target.value, data_fim: moment(event.target.value).add(1, 'months').format('YYYY-MM-DD') })
                                        }} />
                                </div>
                            </div>
                            {
                                this.state.data_inicio &&
                                <div style={{ padding: '0.2vw' }} className="grupo__campo">
                                    Data final:
                                    <div className="grupo__campo__form grupo__campo--input--select">
                                        <input style={{ width: '150px' }} type='date' value={this.state.data_fim}
                                            max={moment(this.state.data_inicio).add(1, 'months').format('YYYY-MM-DD')}
                                            min={moment(this.state.data_inicio).format('YYYY-MM-DD')}
                                            onChange={(event) => {
                                                this.setState({ data_fim: event.target.value })
                                            }}
                                        />
                                    </div>

                                </div>
                            }
                            {
                                this.state.data_inicio &&
                                <div style={{ padding: '0.2vw' }} className="grupo__campo">
                                    Mês e ano de cobrança:
                                    <div className="grupo__campo__form grupo__campo--input--select">
                                        <input style={{ width: '150px' }} type='month' value={this.state.mes_ano}
                                            onChange={(event) => {
                                                this.setState({ mes_ano: event.target.value })
                                            }}
                                        />
                                    </div>
                                </div>
                            }
                            {
                                this.state.data_inicio &&
                                <>
                                    <div style={{ padding: '0.2vw' }}>
                                        <button className='btn__primary button'
                                            onClick={(event) => {
                                                if (new Date(moment(this.state.data_inicio).add(1, 'months').format('YYYY-MM-DD')) >= new Date(moment(this.state.data_fim).format('YYYY-MM-DD'))) {
                                                    this.boletos(this.state.data_inicio, this.state.data_fim, this.state.mes_ano)
                                                }
                                                else {
                                                    alert('Período execede 1 mês')
                                                }
                                            }}
                                        >Filtrar</button>
                                    </div>
                                    <div>
                                        <button
                                            className="btn__primary--outline button"
                                            onClick={() => {
                                                const payload = {
                                                    imobiliaria_id: jwt_decode(localStorage.getItem('autenticado_freedom')).imobiliaria_id,
                                                    boletos: this.state.boletos.filter((b) => {
                                                        return b.nome === 'Aluguel'
                                                    }),
                                                };

                                                localStorage.setItem('simulacao_payload', JSON.stringify(payload));
                                                window.open('/freedom/simulacao/boleto', '_blank');
                                            }}
                                        >
                                            Simular Cobranças
                                        </button>
                                    </div>
                                    <div style={{ padding: '0.2vw' }}>
                                        <button className='btn__primary--outline button' onClick={this.genCSV}>
                                            Gerar Excel
                                        </button>
                                    </div>
                                </>

                            }
                        </div>
                        {
                            this.state.total_boletos > 0 &&
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <button hidden={this.disable_button()} className='btn__primary button'
                                    id="gen_boletos"
                                    onClick={() => {
                                        this.setState({
                                            modal_titulo: `Gerar boletos`,
                                            modal_corpo: <div className='text-center' style={{ padding: '2vw', fontSize: '1.1em' }}>
                                                Deseja realmente prosseguir? <br />Serão gerados {this.state.total_boletos} boletos
                                            </div>,
                                            modal_botoes: <>
                                                <button className='button btn__primary--outline' onClick={() => { this.fecharModal() }}>Não</button>
                                                <button className='button btn__primary' onClick={() => { this.fecharModal(); this.boletosGerar() }}>Sim</button>
                                            </>
                                        })
                                        this.abrirModal()
                                    }}> Gerar boletos </button>
                            </div>
                        }
                    </div>
                    <div style={{ padding: '1.3vw', marginBottom: '-20px' }}>
                        <label>Total de boletos: {this.state.total_boletos}</label>
                        {this.state.servicos.length > 0 && (
                            <div style={{ fontSize: '12px', marginTop: '10px' }}>
                                <strong>Legenda de Destinação de Valores:</strong>
                                <span style={{
                                    backgroundColor: '#28a745',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '18px',
                                    height: '18px',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '10px',
                                    fontWeight: 'bold',
                                    marginLeft: '10px',
                                    marginRight: '3px'
                                }}>P</span> Proprietário
                                <span style={{
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '18px',
                                    height: '18px',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '10px',
                                    fontWeight: 'bold',
                                    marginLeft: '10px',
                                    marginRight: '3px'
                                }}>I</span> Imobiliária
                                <span style={{
                                    backgroundColor: '#dc3545',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '18px',
                                    height: '18px',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '10px',
                                    fontWeight: 'bold',
                                    marginLeft: '10px',
                                    marginRight: '3px'
                                }}>L</span> Locatário
                            </div>
                        )}
                    </div>
                    <div className='table mt-4'>
                        <table className='table'>
                            <thead>
                                <tr>
                                    <th>
                                        <div class="thead__item">
                                            <label># Contrato</label>
                                        </div>
                                    </th>
                                    <th>
                                        <div class="thead__item">
                                            <label>Parcela</label>
                                        </div>
                                    </th>
                                    <th>
                                        <div class="thead__item">
                                            <label>Mês referente</label>
                                        </div>
                                    </th>
                                    <th>
                                        <div class="thead__item">
                                            <label>Vencimento</label>
                                        </div>
                                    </th>
                                    <th>
                                        <div class="thead__item">
                                            <label>Valor do aluguel</label>
                                        </div>
                                    </th>

                                    {this.state.servicos.map(servicoInfo => (
                                        <th key={servicoInfo.nome}>
                                            <div class="thead__item">
                                                <label>{servicoInfo.nome}</label>
                                            </div>
                                        </th>
                                    ))}

                                    <th>
                                        <div class="thead__item">
                                            <label>Valor do boleto</label>
                                        </div>
                                    </th>
                                    <th>
                                        <div class="thead__item">
                                            <label>Vencimento do boleto</label>
                                        </div>
                                    </th>
                                    <th>
                                        <div class="thead__item">
                                            <label>Pago?</label>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.total_boletos === 0 && (
                                    <tr>
                                        <th className='text-center' colSpan={8 + this.state.servicos.length}>
                                            {this.state.mensagem}
                                        </th>
                                    </tr>
                                )}
                                {this.state.boletos.filter((p) => {
                                    return p.nome === 'Aluguel'
                                }).map(this.listarBoletos)}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="content-modal" id="modal" style={{ display: 'none' }}>
                    <div className="modal">
                        <div className="modal-head">
                            {this.state.modal_titulo}
                        </div>
                        <div className="modal-body">
                            <div className='modal-scroll'>
                                {this.state.modal_corpo}
                            </div>
                        </div>
                        <div className="modal-foot">
                            {this.state.modal_botoes}
                        </div>
                    </div>
                </div>
                {this.state.modalErroGerarBoleto && this.state.modalErroGerarBoleto}
            </>
        );
    }
}

export default GerarBoletos;
